export const extractMeta = () => {
  return (window.location.search + '').replace(/^\?/, '')
}
